import store from "../reducers/configureStore";

export default function hasPermission(permCode) {
    let permissions = (store.store.getState().auth as any).permissions;
    
    return permissions[permCode] != undefined ? permissions[permCode] : false;
}
